module.exports = __webpack_public_path__ + "media/images/orcid_id-f0b4a6d8581834271a5e988a7f106d88.svg";